/**
 * globalPopup — Đăng ký tập trung tất cả popup components cho useDialog
 * Mỗi popup có 1 key duy nhất trong PopupKey, được register một lần tại đây
 * CreatedBy: dbhuan (14/06/2026)
 */
import { registerPopup } from "@/composables/useDialog";

/** Danh sách key popup — dùng khi gọi openDialog(key, ...) */
export const PopupKey = {
  /** Popup xem lịch sử chính sách bảo mật */
  HistoryPrivacyPolicy: "HistoryPrivacyPolicy",
  /** Popup chi tiết/thêm mới user trên SubAccount */
  UserDetail: "UserDetail",
  /** Popup chi tiết giao dịch */
  TransactionDetails: "TransactionDetails",
  /** Popup chi tiết hoàn tiền */
  RefundDetail: "RefundDetail",
  /** Popup xác nhận xóa tài khoản con */
  PopupDeleteSubUser: "PopupDeleteSubUser",
  /** Popup kết nối dịch vụ Misa */
  PopupSettingMisa: "PopupSettingMisa",
  /** Popup kết nối website, ứng dụng */
  PopupSettingWebsite: "PopupSettingWebsite",
};

// Đăng ký toàn bộ popup components
export const registerGlobalPopup = () => {
  registerPopup(
    PopupKey.HistoryPrivacyPolicy,
    () => import("@/views/dashboard/HistoryPrivacyPolicy.vue"),
  );
  registerPopup(PopupKey.UserDetail, () => import("@/views/SubAccount/UserDetail.vue"));
  registerPopup(
    PopupKey.TransactionDetails,
    () => import("@/views/transaction/TransactionDetails.vue"),
  );
  registerPopup(
    PopupKey.PopupDeleteSubUser,
    () => import("@/views/SubAccount/PopupDeleteSubUser.vue"),
  );
  registerPopup(PopupKey.RefundDetail, () => import("@/views/Refund/RefundDetails.vue"));
  registerPopup(
    PopupKey.PopupSettingMisa,
    () => import("@/views/MemasSetting/PopupSettingMisaV2.vue"),
  );
  registerPopup(
    PopupKey.PopupSettingWebsite,
    () => import("@/views/MemasSetting/PopupSettingWebsiteDiffirentV2.vue"),
  );
};
